
const Default = () => {
    return (
        <h1>Default</h1>
    )
}

export default Default;
